import { render, staticRenderFns } from "./modal-gip.vue?vue&type=template&id=319ef26e&"
import script from "./modal-gip.vue?vue&type=script&lang=ts&"
export * from "./modal-gip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports